import React from 'react';
import { makeStyles } from '@material-ui/core';
import { AMOUNT_OPTIONS, FORM_COLORS, MAIN_PRICE_OPTIONS } from '../constants';
import { useFormStyles } from '../styles';
import { TabComponentProps } from '../types';
import { LabeledField, SelectInput } from '../components/FormControls';
import { InfoBox } from '../components/InfoBox';

const useStyles = makeStyles(() => ({
  stockGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 10,
    marginBottom: 14,
  },
  stockCard: {
    background: FORM_COLORS.bg,
    border: `0.5px solid ${FORM_COLORS.border}`,
    borderRadius: 8,
    padding: '10px 12px',
  },
  stockLabel: {
    fontSize: 10,
    color: FORM_COLORS.textSecondary,
    fontWeight: 500,
    marginBottom: 4,
  },
  stockInput: {
    width: '100%',
    padding: '5px 8px',
    fontSize: 12,
    border: `0.5px solid ${FORM_COLORS.border}`,
    borderRadius: 8,
    fontFamily: 'inherit',
    background: FORM_COLORS.white,
    color: FORM_COLORS.text,
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
      borderColor: FORM_COLORS.pink,
    },
  },
  priceSection: {
    borderTop: `0.5px solid ${FORM_COLORS.border}`,
    paddingTop: 16,
  },
}));

export const StockPricesTab = ({ values, onChange }: TabComponentProps) => {
  const classes = useStyles();
  const formClasses = useFormStyles();

  const stockFields: { key: 'stockQty' | 'alarmBase' | 'alarmMin'; label: string }[] = [
    { key: 'stockQty', label: 'Cantidad en stock' },
    { key: 'alarmBase', label: 'Alarma base' },
    { key: 'alarmMin', label: 'Alarma mínima' },
  ];

  return (
    <div>
      <InfoBox tone="pink">
        Las alarmas de stock generan una notificación por mail cuando el stock llega al umbral. El
        stock inicial se sincroniza con el administrador de stock.
      </InfoBox>

      <div className={classes.stockGrid}>
        {stockFields.map((field) => (
          <div key={field.key} className={classes.stockCard}>
            <div className={classes.stockLabel}>{field.label}</div>
            <input
              className={classes.stockInput}
              type="number"
              value={values[field.key]}
              onChange={(event) => onChange(field.key, event.target.value)}
              placeholder="0"
            />
          </div>
        ))}
      </div>

      <div className={classes.priceSection}>
        <p className={formClasses.sectionTitle}>
          Configuración de precios visibles en el ecommerce
        </p>
        <div className={formClasses.grid}>
          <LabeledField label="Main price">
            <SelectInput
              value={values.mainPrice}
              onChange={(value) => onChange('mainPrice', value)}
              options={MAIN_PRICE_OPTIONS}
            />
          </LabeledField>
          <LabeledField label="Main amount">
            <SelectInput
              value={values.mainAmount}
              onChange={(value) => onChange('mainAmount', value)}
              options={AMOUNT_OPTIONS}
            />
          </LabeledField>
          <LabeledField label="Alter price">
            <SelectInput
              value={values.alterPrice}
              onChange={(value) => onChange('alterPrice', value)}
              options={MAIN_PRICE_OPTIONS}
            />
          </LabeledField>
          <LabeledField label="Alter amount">
            <SelectInput
              value={values.alterAmount}
              onChange={(value) => onChange('alterAmount', value)}
              options={AMOUNT_OPTIONS}
            />
          </LabeledField>
        </div>
      </div>
    </div>
  );
};
